import { __decorate, __metadata } from "tslib";
// NPM
import { Component, Vue, Watch } from "vue-property-decorator";
import { AuthModule } from "@/store/modules/auth.module";
import Swal from "sweetalert2";
Component.registerHooks(["onIdle", "onActive"]);
let SessionTimer = /** @class */ (() => {
    let SessionTimer = class SessionTimer extends Vue {
        constructor() {
            super(...arguments);
            this.excludedRoutes = ["ClockWork"];
            this.idleMessage = "active";
        }
        timer(pagehasBecomeIdle) {
            if (this.nonExludedRoutePage) {
                if (pagehasBecomeIdle === true) {
                    let timerInterval;
                    Swal.fire({
                        title: "Session Timeout Alert!",
                        position: "bottom-right",
                        html: "This app has been inactive for 1 hour and will timeout in <b></b> seconds.",
                        timer: 30000,
                        confirmButtonText: "I'm here!",
                        timerProgressBar: true,
                        willOpen: () => {
                            timerInterval = setInterval(() => {
                                Swal.getContent().querySelector("b").textContent = Math.floor(Swal.getTimerLeft() / 1000).toString();
                            }, 1000);
                        },
                        willClose: () => {
                            clearInterval(timerInterval);
                        },
                    }).then((result) => {
                        if (result.dismiss === Swal.DismissReason.timer) {
                            AuthModule.SessionTimeout();
                        }
                    });
                }
                else {
                    Swal.close();
                }
            }
        }
        onIdle() {
            this.idleMessage = "idle";
        }
        onActive() {
            this.idleMessage = "active";
        }
        get nonExludedRoutePage() {
            return !this.excludedRoutes.some((x) => x === this.$route.name);
        }
    };
    __decorate([
        Watch("isAppIdle"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], SessionTimer.prototype, "timer", null);
    SessionTimer = __decorate([
        Component
    ], SessionTimer);
    return SessionTimer;
})();
export default SessionTimer;
